// * GET =====================================
export const DASHBOARD_GET_WIDGET_PAGES = (dashboardId: string) =>
  `/dashboard/${dashboardId}/widget_pages`;

// * PATCH ===================================
export const DASHBOARD_PATCH_PATCH = (dashboardId: string) =>
  `/dashboard/${dashboardId}/patch`;

export const DASHBOARD_PATCH_CONTEXT_MENU_OPTIONS = (dashboardId: string) =>
  `/dashboard/${dashboardId}/context_menu_options`;

// * POST ====================================
export const DASHBOARD_POST_COPY_DASHBOARD = `/dashboard/copy_dashboard`;

export const DASHBOARD_POST_CREATE_WIDGET_PAGE = (dashboardId: string) =>
  `/dashboard/${dashboardId}/create_widget_page`;

export const DASHBOARD_POST_EDIT_WIDGET_PAGE = (dashboardId: string) =>
  `/dashboard/${dashboardId}/edit_widget_page`;

export const DASHBOARD_POST_REORDER_WIDGET_PAGES = (dashboardId: string) =>
  `/dashboard/${dashboardId}/reorder_widget_pages`;

export const DASHBOARD_POST_DELETE_WIDGET_PAGE = (dashboardId: string) =>
  `/dashboard/${dashboardId}/delete_widget_page`;

// * DELETE ==================================
export const DASHBOARD_DELETE = (dashboardId: string) =>
  `/dashboard/${dashboardId}`;

// * PUT =====================================
export const DASHBOARD_PUT = `/dashboard`;
